/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManualPro } from '../models/ManualPro';
import type { ManualProCreate } from '../models/ManualProCreate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProService {
    /**
     * Get Manual Pros
     * @param userId
     * @param offset
     * @param limit
     * @returns ManualPro Successful Response
     * @throws ApiError
     */
    public static getManualProsProManualGet(
        userId?: (number | null),
        offset?: number,
        limit: number = 100,
    ): CancelablePromise<Array<ManualPro>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pro/manual',
            query: {
                'user_id': userId,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Manual Pro
     * @param requestBody
     * @returns ManualPro Successful Response
     * @throws ApiError
     */
    public static createManualProProManualPost(
        requestBody: ManualProCreate,
    ): CancelablePromise<ManualPro> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/pro/manual',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Manual Pro
     * @param manualProId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static deleteManualProProManualManualProIdDelete(
        manualProId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/pro/manual/{manual_pro_id}',
            path: {
                'manual_pro_id': manualProId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
